import React from 'react';
import lockRed from '../assets/lock-red.svg';
import EmptyState from '@atlaskit/empty-state';
import messages from '../messages';
import { injectIntl, type WrappedComponentProps } from 'react-intl-next';
import ViewTracker from '../../../common/analytics/view-tracker';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/analytics-bridge';

const AccessRevoked = injectIntl(({ intl: { formatMessage } }: WrappedComponentProps) => {
	return (
		<>
			<EmptyState
				imageUrl={lockRed}
				imageHeight={126}
				imageWidth={96}
				header={formatMessage(messages.requestAccessRevokedTitle)}
				description={formatMessage(messages.requestAccessRevokedSubtitle)}
				testId="confluence-project-pages.cross-join.access-revoked"
			/>
			<ViewTracker />
		</>
	);
});

export default () => (
	<ContextualAnalyticsData sourceName="projectPagesAccessRevoked" sourceType={SCREEN}>
		<AccessRevoked />
	</ContextualAnalyticsData>
);
